<gc-modal
  [headerTitle]="setModalHeader() | translate"
  [primaryButtonText]="'multiPointModal.closeBtn' | translate"
  [width]="'fullscreen'"
  (closeModal)="closeModal()"
  (primaryButtonClicked)="closeModal()"
>
  <gc-tabs
    [tabWidth]="'full'"
    [initialTabIndex]="activeTab"
    (activeTabChanged)="onActiveTabChanged($event)"
  >
    @if (multiPointData.tabs.includes(HcTab)) {
      <gc-tab
        [label]="'multiPointModal.tabs.hc' | translate"
        [templateRef]="HC"
      >
      </gc-tab>
    }
    @if (multiPointData.tabs.includes(HpTab)) {
      <gc-tab
        [label]="'multiPointModal.tabs.hp' | translate"
        [templateRef]="HP"
      ></gc-tab>
    }
    @if (multiPointData.tabs.includes(wellTab)) {
      <gc-tab
        [label]="'multiPointModal.tabs.well' | translate"
        [templateRef]="WELL"
      ></gc-tab>
    }
  </gc-tabs>

  <ng-template #HC>
    <div class="tab-content">
      <app-hc-wrapper
        [ifs]="ifs"
        [multiPointData]="multiPointData"
        (dismiss)="closeModal()"
      ></app-hc-wrapper>
    </div>
  </ng-template>

  <ng-template #HP>
    <div class="tab-content">
      <app-hp-table
        [multiPointData]="multiPointData"
        (dismiss)="closeModal()"
      ></app-hp-table>
    </div>
  </ng-template>

  <ng-template #WELL>
    <div class="tab-content">
      <app-well-table
        [wellData]="multiPointData.data.well"
        (dismiss)="closeModal()"
      ></app-well-table>
    </div>
  </ng-template>
</gc-modal>
